// extracted by mini-css-extract-plugin
export default {"menu":"navbarMenuLinks_menu__2ciO8","menuItem":"navbarMenuLinks_menuItem__hrfgL","menuButton":"navbarMenuLinks_menuButton__4lZ50"};